var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 12.5H10.8332V7.5H13.3332L9.99984 3.33334L6.6665 7.5H9.1665V12.5Z",
    fill: "#77787D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 15H3.33317V9.16666H1.6665V15C1.6665 15.9192 2.414 16.6667 3.33317 16.6667H16.6665C17.5857 16.6667 18.3332 15.9192 18.3332 15V9.16666H16.6665V15Z",
    fill: "#77787D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpload);
export default __webpack_public_path__ + "static/media/ic-upload.f967d58788848e34b03b77219b5344af.svg";
export { ForwardRef as ReactComponent };